import React, { useEffect, useState } from "react";
import StudentTable from "../../../components/Table/StudentTable";
import {
  useGetAllAssignmentMarkQuery,
  useGetAllQuizMarkQuery,
  useGetAllStudentQuery,
} from "../../../features/Student/Leaderboard/leaderboardApi";

const positonTableHeaders = [
  "Rank",
  "Name",
  "Quiz Mark",
  "Assignment Mark",
  "Total",
];
export default function Top20Position() {
  const { data: allStudent, isSuccess: studentSuccess } =
    useGetAllStudentQuery();
  const { data: allQuizMark, isSuccess: quizSuccess } =
    useGetAllQuizMarkQuery();
  const { data: allAssignmentMark, isSuccess: assignmentSuccess } =
    useGetAllAssignmentMarkQuery();
  const [rankPosition, setRankPosition] = useState([]);
  useEffect(() => {
    if (studentSuccess && quizSuccess && assignmentSuccess) {
      setRankPosition(
        calculateTopPosition(allStudent, allQuizMark, allAssignmentMark)
      );
    }
  }, [studentSuccess, quizSuccess, assignmentSuccess]);

  return (
    <>
      <StudentTable headers={positonTableHeaders} borderActive={true}>
        {rankPosition?.length > 0 &&
          rankPosition.map((row, index) => (
            <tr key={`${index}`} className="border-b border-slate-600/50">
              <td className="table-td text-center">{row?.rank}</td>
              <td className="table-td text-center">{row?.name}</td>
              <td className="table-td text-center">{row?.quizMark}</td>
              <td className="table-td text-center">{row?.assignmentMark}</td>
              <td className="table-td text-center">{row?.totalMark}</td>
            </tr>
          ))}
      </StudentTable>
    </>
  );
}

export function calculateTopPosition(QuizMark, AssignmentMark) {
  // Combine the assignment and quiz marks of each student
  const combinedMarks = {};
  AssignmentMark.forEach((assignment) => {
    const studentId = assignment.student_id;
    if (!combinedMarks[studentId]) {
      combinedMarks[studentId] = {
        id: studentId,
        name: assignment.student_name,
        assignmentMarks: [],
        quizMarks: [],
      };
    }
    combinedMarks[studentId].assignmentMarks.push(assignment.mark);
  });
  console.log("combinedMarks", combinedMarks);
  QuizMark.forEach((quiz) => {
    const studentId = quiz.student_id;
    if (!combinedMarks[studentId]) {
      combinedMarks[studentId] = {
        id: studentId,
        name: quiz.student_name,
        assignmentMarks: [],
        quizMarks: [],
      };
    }
    combinedMarks[studentId].quizMarks.push(quiz.mark);
  });

  // Calculate the total marks of each student
  const studentsWithTotalMarks = Object.values(combinedMarks).map((student) => {
    const totalMark =
      student.assignmentMarks.reduce((acc, val) => acc + val, 0) +
      student.quizMarks.reduce((acc, val) => acc + val, 0);
    return {
      ...student,
      totalMark,
    };
  });

  // Sort the students based on their total marks
  studentsWithTotalMarks.sort((a, b) => b.totalMark - a.totalMark);

  // Create a rank list of the top 20 students, or more if there are ties
  let rank = 1;
  let prevMark = -1;
  const rankList = studentsWithTotalMarks.reduce((acc, student) => {
    if (prevMark !== student.totalMark) {
      rank = acc.length + 1;
      prevMark = student.totalMark;
    }
    const rankObj = {
      rank,
      id: student.id,
      name: student.name,
      quizMark: student?.quizMarks,
      assignmentMark: student?.assignmentMarks,
      totalMark: student.totalMark,
    };
    acc.push(rankObj);
    return acc;
  }, []);

  // Only include the top 20 students
  const top20RankList = rankList.slice(0, 20);
  return top20RankList;
}
